import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AIBookPage = lazy(() => import('../pages/ai-book/page'));
const AIConsultingPage = lazy(() => import('../pages/ai-consulting/page'));
const CalendarPage = lazy(() => import('../pages/calendar/page'));
const RealEstatePage = lazy(() => import('../pages/real-estate/page'));
const TravelAuthorityPage = lazy(() => import('../pages/travel-authority/page'));
const BooksPage = lazy(() => import('../pages/books/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const AIStrategyPage = lazy(() => import('../pages/ai-strategy/page'));
const ProcessAutomationPage = lazy(() => import('../pages/process-automation/page'));
const MachineLearningPage = lazy(() => import('../pages/machine-learning/page'));
const DigitalTransformationPage = lazy(() => import('../pages/digital-transformation/page'));
const AIImplementationPage = lazy(() => import('../pages/ai-implementation/page'));
const AEOBlogPage = lazy(() => import('../pages/aeo-blog/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const StorePage = lazy(() => import('../pages/store/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const DownloadPage = lazy(() => import('../pages/download/page'));
const CATaxForeclosuresPage = lazy(() => import('../pages/ca-tax-foreclosures/page'));
const NVTaxForeclosuresPage = lazy(() => import('../pages/nv-tax-foreclosures/page'));
const TaxForeclosuresPage = lazy(() => import('../pages/tax-foreclosures/page'));
const ForeclosureRecoveryPage = lazy(() => import('../pages/foreclosure-recovery/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/ai-book',
    element: <AIBookPage />,
  },
  {
    path: '/ai-consulting',
    element: <AIConsultingPage />,
  },
  {
    path: '/calendar',
    element: <CalendarPage />,
  },
  {
    path: '/real-estate',
    element: <RealEstatePage />,
  },
  {
    path: '/travel-authority',
    element: <TravelAuthorityPage />,
  },
  {
    path: '/books',
    element: <BooksPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/ai-strategy',
    element: <AIStrategyPage />,
  },
  {
    path: '/process-automation',
    element: <ProcessAutomationPage />,
  },
  {
    path: '/machine-learning',
    element: <MachineLearningPage />,
  },
  {
    path: '/digital-transformation',
    element: <DigitalTransformationPage />,
  },
  {
    path: '/ai-implementation',
    element: <AIImplementationPage />,
  },
  {
    path: '/aeo-blog',
    element: <AEOBlogPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/store',
    element: <StorePage />,
  },
  {
    path: '/download',
    element: <DownloadPage />,
  },
  {
    path: '/ca-tax-foreclosures',
    element: <CATaxForeclosuresPage />,
  },
  {
    path: '/nv-tax-foreclosures',
    element: <NVTaxForeclosuresPage />,
  },
  {
    path: '/tax-foreclosures',
    element: <TaxForeclosuresPage />,
  },
  {
    path: '/foreclosure-recovery',
    element: <ForeclosureRecoveryPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
